import api from './api';

class Insights {
  // AltLender Insight Events
  altLender = {
    cardClick: (lenderId: number, loanType: string) => trackAltLender('alt-lender-card-click', lenderId, loanType),
    cardView: (lenderId: number, loanType: string) => trackAltLender('alt-lender-card-view', lenderId, loanType),
  };

  // AltSolution Insight Events
  altSolution = {
    cardClick: (solutionId: number, loanType: string, loanOptionId: number, propertyTypeId: number) =>
      trackAltSolution('card-click', solutionId, loanType, loanOptionId, propertyTypeId),
    cardView: (solutionId: number, loanType: string, loanOptionId: number, propertyTypeId?: number) =>
      trackAltSolution('card-view', solutionId, loanType, loanOptionId, propertyTypeId),
    contactClick: (solutionId: number, loanType: string, loanOptionId: number, propertyTypeId: number) =>
      trackAltSolution('contact-click', solutionId, loanType, loanOptionId, propertyTypeId),
    finmoCTAClick: (solutionId: number, loanType: string, loanOptionId: number, propertyTypeId: number) =>
      trackAltSolution('finmo-cta-click', solutionId, loanType, loanOptionId, propertyTypeId),
  };
}

const track = (endpoint: string, params: Record<string, unknown>) => {
  api.post(`insights/${endpoint}`, params);
};

// Make function public so it can be stubbed in E2E tests
(window as unknown as Record<string, unknown>)['insights.track'] = track;

const trackAltLender = (eventName: string, lenderId: number, loanType: string) =>
  ((window as unknown as Record<string, unknown>)['insights.track'] as typeof track)('alt-lender-event', {
    name: eventName,
    alt_lender_id: lenderId,
    loan_type: loanType,
  });

const trackAltSolution = (
  eventName: string,
  solutionId: number,
  loanType: string,
  loanOptionId: number,
  propertyTypeId?: number
) =>
  ((window as unknown as Record<string, unknown>)['insights.track'] as typeof track)(`alt-solution-${eventName}`, {
    alt_solution_id: solutionId,
    loan_type: loanType,
    loan_option_id: loanOptionId,
    property_type_id: propertyTypeId,
  });

export default new Insights();
